export default __webpack_public_path__ + "static/media/line.308db387.svg";